<template>
    <transition>
    <div class="container-fluid page-content">
        <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center page-header-row gap-3">
            <div>
                <h4 class="page-title text-slate-800 fw-bold mb-1">Store Requisition</h4>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item"><a href="/" class="text-muted"><i class="fas fa-home me-1"></i>Home</a></li>
                        <li class="breadcrumb-item"><a href="javascript:void(0);" class="text-muted">Requisition</a></li>
                        <li class="breadcrumb-item active text-indigo fw-medium" aria-current="page">Store Requisition List</li>
                    </ol>
                </nav>
            </div>
            <div>
                <a href="/store-purchase-requisition" class="btn btn-premium px-3 py-2 d-flex align-items-center gap-2">
                    <i class="fas fa-plus"></i>
                    <span>New Store Requisition</span>
                </a>
            </div>
        </div>

        <!-- Modal -->
        <Modal @close="toggleModal()" :modalActive="modalActive">
            <div class="modal-content scrollbar-width-thin modal-premium modal-premium-md">
                <div class="modal-header"> 
                    <h4>Requisition Details ({{ requisition.outlet_name }})</h4>
                    <button @click="toggleModal()" type="button" class="btn-close-custom">×</button>                    
                </div>

                <div class="modal-body p-4">
                    <div class="card border-0 bg-light-custom mb-3 p-3">
                        <div class="row g-3">
                            <div class="col-md-6">
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Requisition No:</span>
                                    <span class="text-slate-800 fw-bold">{{ requisition.requisition_no }}</span>
                                </div>
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Requisition Qty:</span>
                                    <span class="text-slate-800 fw-bold">{{ requisition.total_quantity }}</span>
                                </div>
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Approve Qty:</span>
                                    <span class="text-slate-800 fw-bold text-success">{{ requisition.total_approve_quantity }}</span>
                                </div>
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Status:</span>
                                    <span class="fw-bold" v-html="requisition.approve_status_name"></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Date:</span>
                                    <span class="text-slate-800 fw-bold">{{ requisition.requisition_date }}</span>
                                </div>
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Requisition Amount:</span>
                                    <span class="text-slate-800 fw-bold">{{ requisition.total_amount }}</span>
                                </div>
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Approve Amount:</span>
                                    <span class="text-slate-800 fw-bold text-success">{{ requisition.total_approve_amount }}</span>
                                </div>
                                <div class="d-flex align-items-center mb-2">
                                    <span class="text-muted fw-medium me-2" style="width: 150px;">Note:</span>
                                    <span class="text-slate-800 fw-bold">{{ requisition.remarks }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h5 class="text-slate-800 fw-bold mb-3">Product Details</h5>
                    
                    <div class="table-responsive border rounded-3 mb-2">
                        <table class="table table-centered mb-0">
                            <thead class="table-light">
                                <tr class="text-uppercase" style="font-size: 11px; letter-spacing: 0.05em;">
                                    <th class="text-center">SL</th>
                                    <th>Name</th>
                                    <th class="text-center">Barcode</th>
                                    <th class="text-center">UOM</th>
                                    <th class="text-right">Purchase Price</th>
                                    <th class="text-right">MRP Price</th>
                                    <th class="text-center">Crt Size</th>
                                    <th class="text-center">Req. Qty</th>
                                    <th class="text-center">App. Qty</th>
                                    <th class="text-right">Amount</th>
                                    <th class="text-right">App. Amount</th>
                                </tr>
                            </thead>
                            <tbody v-if="product_items.length > 0">
                                <tr v-for="(product_item, i) in product_items" :key="i" style="font-size: 13px;">
                                    <td class="text-center text-muted">{{ i + 1 }}</td>
                                    <td class="fw-semibold text-slate-800">{{ product_item.product_name }}</td>
                                    <td class="text-center">{{ product_item.product_code }}</td>
                                    <td class="text-center"><span class="badge bg-light text-dark">{{ product_item.purchase_unit }}</span></td>
                                    <td class="text-right">{{ parseFloat(product_item.cost_price).toFixed(2) }}</td>
                                    <td class="text-right">{{ parseFloat(product_item.mrp_price).toFixed(2) }}</td>
                                    <td class="text-center">{{ product_item.carton_size }}</td>
                                    <td class="text-center fw-bold">{{ product_item.req_qty }}</td>
                                    <td class="text-center fw-bold text-success">{{ product_item.approve_qty }}</td>
                                    <td class="text-right fw-semibold">{{ parseFloat(product_item.req_qty * product_item.cost_price).toFixed(2) }}</td>
                                    <td class="text-right fw-bold text-success">{{ parseFloat(product_item.approve_qty * product_item.cost_price).toFixed(2) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Modal>

        <div class="row">
            <div class="col-12">
                <div class="card border-0 shadow-sm table-card mt-3">
                    <div class="card-body p-0">
                        <div class="tableFilters p-3 border-bottom" v-if="items.length > 0 || search || selectedCompanyId">
                            <div class="row align-items-center justify-content-between g-2">
                                <div class="col-md-4">
                                    <div class="position-relative search-container">
                                        <i class="fas fa-search search-icon text-muted"></i>
                                        <input type="text" class="form-control-custom search-input" v-model="search" placeholder="Search requisitions...">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <select class="form-select-custom" v-model="selectedCompanyId">
                                        <option value="">--- All Companies ---</option>
                                        <option v-for="(company, i) in companies" :key="i" :value="company.id">{{ company.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-centered mb-0" v-if="!loading">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 60px;">SL</th>
                                        <th class="text-center">Req. Date</th>
                                        <th class="text-center">Req. No</th>
                                        <th>Company</th>
                                        <th>Outlet</th>
                                        <th class="text-center">App. Status</th>
                                        <th class="text-center">Ord. Status</th>
                                        <th>Remarks</th>
                                        <th class="text-end" style="width: 100px;">Action</th>
                                    </tr>
                                </thead>
                                <tbody v-if="filteredItems.length > 0">
                                    <tr v-for="(item, index) in filteredItems" :key="index">
                                        <td class="text-center text-muted">{{ index + 1 }}</td>
                                        <td class="text-center fw-medium">{{ item.requisition_date }}</td>
                                        <td class="text-center fw-bold text-indigo">{{ item.requisition_no }}</td>
                                        <td class="fw-semibold text-slate-800">{{ item.company_name || '-' }}</td>
                                        <td class="fw-semibold text-slate-800">{{ item.outlet_name }}</td>
                                        <td class="text-center" v-html="item.approve_status_name"></td>
                                        <td class="text-center" v-html="item.order_status_name"></td>
                                        <td class="text-muted">{{ item.remarks || '-' }}</td>
                                        <td class="text-end actions">
                                            <div class="dropdown float-end">
                                                <a href="#" class="btn btn-icon dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i class="mdi mdi-dots-vertical"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end dropdown-premium shadow-sm">
                                                    <a href="javascript:void(0);" class="dropdown-item text-primary" @click="requisitionView(item)" v-if="permission['list-view']">
                                                        <i class="fas fa-eye me-2"></i> View
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item text-primary" @click.prevent="printItem(item)">
                                                        <i class="mdi mdi-printer-outline me-2"></i> Print
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item text-warning" v-if="permission['list-purchase-requisition-edit'] && (item.approve_status != 2 && item.approve_status != 1)" @click="edit(item)">
                                                        <i class="fas fa-edit me-2"></i> Edit
                                                    </a>
                                                    <a href="javascript:void(0);" class="dropdown-item text-info" v-if="item.approve_status == 1 && item.status != 2" @click="$router.push('/purchase/rfq')">
                                                        <i class="mdi mdi-file-document-outline me-2"></i> Create RFQ / CS
                                                    </a>
                                                    <!-- Kept for backward compatibility if needed, but hidden for strict workflow -->
                                                    <!-- <a href="javascript:void(0);" class="dropdown-item text-secondary" v-if="permission['list-requisition-purchase-order'] && (item.approve_status == 1 && item.order_status != 2)" @click="requisitionPurchaseOrder(item)">
                                                        <i class="mdi mdi-arrow-right-circle-outline me-2"></i> Direct PO (Emergency)
                                                    </a> -->
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- No Data Found -->
                        <div v-if="!loading && filteredItems.length === 0" class="text-center py-5">
                            <img src="../../assets/image/loading.gif" class="mb-3 opacity-25" style="width: 80px; filter: grayscale(1);" />
                            <h5 class="text-muted fw-semibold">No Requisitions Found</h5>
                            <p class="text-muted mb-0 small">Try adjusting your filters or search query.</p>
                        </div>

                        <!-- Loading State -->
                        <div v-if="loading" class="text-center py-5">
                            <div class="spinner-premium mb-3"></div>
                            <h5 class="text-muted fw-semibold">Loading Requisitions</h5>
                            <p class="text-muted mb-0 small">Please wait a moment...</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal @close="toggleModal()">
            <div class="modal-content scrollbar-width-thin orderPreview">
                <div class="modal-header"> 
                    <h3> Requisition ({{ requisition.outlet_name }})</h3>
                    <button @click="toggleModal()" type="button" class="btn btn-default">X</button>                    
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card"> 
                                <div class="card-body" id="printArea">
                                    <div style="padding: 0 15px;">
                                        <div class="requisition_details">
                                            <table class="table po_invoice">
                                                <tbody>
                                                <tr>
                                                    <td colspan="4" class="text-center" style="position: relative;">                                                 
                                                        <h5 class="text-uppercase">{{ (requisition.company) ? requisition.company.name : this.retailShopName}}</h5>
                                                        <p>{{ (requisition.company) ? requisition.company.address : this.retailShopAddress }} </p>
                                                        <p>Dhaka, Bangladesh</p>
                                                        <h4>Requisition Invoice</h4>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><label class=" text-left text-bold">Requisition No: </label></td>
                                                    <td><div class=" text-left"> {{ requisition.requisition_no }} </div></td>
                                                    <td><label class=" text-left text-bold">Date: </label></td>
                                                    <td><div class=" text-left"> {{ requisition.requisition_date }} </div></td> 
                                                </tr>
                                                <tr>
                                                    <td><label class="col-md-5 text-left text-bold">Requisition Quantity: </label></td>
                                                    <td><div class=" text-left"> {{ requisition.total_quantity }} </div></td>
                                                    <td><label class="col-md-5 text-left text-bold">Requisition Amount: </label></td>
                                                    <td><div class=" text-left"> {{ requisition.total_amount }} </div></td> 
                                                </tr>
                                                <tr>
                                                    <td><label class="col-md-5 text-left text-bold">Approve Quantity: </label></td>
                                                    <td><div class=" text-left"> {{ requisition.total_approve_quantity }} </div></td>
                                                    <td><label class="col-md-5 text-left text-bold">Approve Amount: </label></td>
                                                    <td><div class=" text-left"> {{ requisition.total_approve_amount }} </div></td> 
                                                </tr>
                                                <tr>
                                                    <td><label class="col-md-5 text-left text-bold">Status: </label></td>
                                                    <td><div class="col-md-7 text-left" v-html="requisition.approve_status_name"></div></td>
                                                    <td><label class="col-md-5 text-left text-bold">Note: </label></td>
                                                    <td><div class="col-md-7 text-left"> {{ requisition.remarks }} </div></td> 
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div> 
                                        <h5> Product Details</h5>
                                    </div>
                                    <div class="table-responsive product_table">
                                        <table class="table table-bordered table-centered table-nowrap">  
                                            <tbody v-if="product_items.length > 0">
                                                <tr class="success item-head">
                                                    <td class="text-center">SL </td> 
                                                    <td class="text-center">Name </td> 
                                                    <td class="text-center">Barcode</td> 
                                                    <td class="text-center">UOM</td>
                                                    <td class="text-center">Purchase Price</td>
                                                    <td class="text-center">MRP Price</td>
                                                    <td class="text-center">Crt Size</td>
                                                    <td class="text-center">Req. Qty </td>
                                                    <td class="text-center">App. Qty </td>
                                                    <td class="text-center">Amount</td>
                                                    <td class="text-center">App. Amount</td> 
                                                </tr> 
                                                <tr v-for="(product_item, i) in product_items" :key="i">
                                                    <td class="text-center">{{ i + 1 }}</td>
                                                    <td>{{ product_item.product_name }}</td>
                                                    <td class="text-center">{{ product_item.product_code }}</td>
                                                    <td class="text-center">{{ product_item.purchase_unit }}</td>
                                                    <td class="text-center">{{ product_item.cost_price }}</td>
                                                    <td class="text-center">{{ product_item.mrp_price }}</td>
                                                    <td class="text-center">{{ product_item.carton_size }}</td>
                                                    <td class="text-center">{{ product_item.req_qty }}</td>
                                                    <td class="text-center">{{ product_item.approve_qty }}</td>
                                                    <td class="text-center">{{ parseFloat(product_item.req_qty * product_item.cost_price ).toFixed(2)}}</td>
                                                    <td class="text-center">{{ parseFloat(product_item.approve_qty * product_item.cost_price ).toFixed(2)}}</td>
                                                    
                                                </tr>
                                            </tbody>
                                            
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
    </transition>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';
import { useProductStore } from '@/stores/product';
import { useRequisitionProductStore } from '@/stores/requisitionProduct';


import Modal from "./../helper/Modal"; 
import axios from 'axios';
export default {
    name: 'PosLeftbar',
    components: {
        Modal
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            btn:'Create',
            items: [],
            productShowBtn: false, 
            suppliers: [],
            outlets: [],
            companies: [],
            product_items: [],
            requisition: '',
            printableModalPrintActive:false,
            search: '',
            selectedCompanyId: ''
        };
    },
    created() {
        this.fetchStoreRequisitionData();
        this.fetchCompanies();
    },
    methods: { 

        checkedRequiredPrimary(){
            if(this.obj.supplier_id && this.obj.order_date &&  this.obj.delivery_date){
                this.productShowBtn = true;
            }else{
                 this.productShowBtn = false;
            }
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;  
            console.log('this.modalActive', this.modalActive)
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            console.log('then',this.isSubmit)
        },

        fetchStoreRequisitionData() { 
            axios.get(this.apiUrl+'/store_requisitions', this.headers)
            .then((res) => {
                this.items = res.data.data;
            }).finally(( ) => {
                this.loading = false;
            });
        }, 
        fetchCompanies() {
            axios.get(this.apiUrl+'/companies', this.headers)
            .then((res) => {
                this.companies = res.data.data;
            });
        },
        edit: function(item) { 
            this.$router.push({name: 'list-purchase-requisition-edit', params:{id:item.id}});
        },

        requisitionView: function(item) {
            axios.get(this.apiUrl+'/store_requisitions/'+item.id, this.headers)
            .then((res) => {
                console.log(res);
                this.requisition = res.data.data.requisition_data;
                this.product_items = res.data.data.requisition_products;
                this.toggleModal();
            }) 
        },

        requisitionPurchaseOrder: function(item)
        {
            this.$router.push({name: 'list-requisition-purchase-order', params:{id: item.id}});
        },

        deleteItem: function(item) {
            console.log('item deleyt=>',item.id);
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) {      
                } 
            }); 
        }, 
        printItem: function (item) { 
            axios.get(this.apiUrl+'/store_requisitions/'+item.id, this.headers)
            .then((res) => {
                console.log(res);
                this.requisition = res.data.data.requisition_data;
                this.product_items = res.data.data.requisition_products;
                this.printContent('printArea');
            }) 
            .catch((err) => { 
                this.$toast.error(err);
            })
        },

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

        ...mapActions(useCartStore, ['removeAllCartItems', 'removeCartItem', 'addCartItem']),
    },

    unmounted() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {
        permission() {
            let pname = this.$route.meta.parent_module;
            let module_name = this.$route.meta.module_name;
            let path_name = this.$route.path; 
            let data = {};
            
            if(!this.$store.getters.userAllPermissions) return data;
            
            try {
                if(this.$route.meta.parent_module){
                    data = this.$store.getters.userAllPermissions[pname]?.[0]?.children?.[path_name] || {};
                }else{
                    data = this.$store.getters.userAllPermissions[module_name]?.[0]?.other_actions || {}; 
                } 
            } catch (e) {
                console.warn('Error computing permissions:', e);
            }
            return data;
        },
        filteredItems() {
            let result = this.items;
            if (this.selectedCompanyId) {
                result = result.filter(item => item.company_id == this.selectedCompanyId);
            }
            if (this.search) {
                const query = this.search.toLowerCase();
                result = result.filter(item => {
                    return (
                        (item.requisition_no && item.requisition_no.toLowerCase().includes(query)) ||
                        (item.outlet_name && item.outlet_name.toLowerCase().includes(query)) ||
                        (item.company_name && item.company_name.toLowerCase().includes(query)) ||
                        (item.requisition_date && item.requisition_date.toLowerCase().includes(query)) ||
                        (item.remarks && item.remarks.toLowerCase().includes(query))
                    );
                });
            }
            return result;
        }
    }
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin { 
    width: 100%;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions a{
    margin-right: 5px;
}

.bg-light-custom {
    background-color: #f8fafc;
    border-radius: 8px;
}
</style>